// components/TalentGroupFilters.tsx
import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import { TalentGroupToggle, ToggleColor } from './TeamDynamic.styles'
import { useTalentContext } from '../Talents/context'

interface Skill {
	id: string
	name: string
	color: string
}

interface TalentGroupFiltersProps {
	chartSkills: Skill[]
	groupSelectionMapping: Record<string, boolean>
	handleGroupToggle: (id: string) => void
	theme: any
}
const TalentGroupFilters: React.FC<TalentGroupFiltersProps> = ({
	chartSkills,
	groupSelectionMapping,
	handleGroupToggle,
	theme
}) => {
	const [{ selectedTalent }] = useTalentContext()
	const matchedSkillId = '67dbf4d42c98d18c9d68381f'

	const hasMatchingSkillWithNull = selectedTalent?.score?.skills?.some(
		skill => skill.skillId === matchedSkillId
	)

	if (hasMatchingSkillWithNull) {
		return (
			<Grid item container alignItems="center" spacing={3}>
				{chartSkills.map(({ id, name, color }) => (
					<Grid item key={id}></Grid>
				))}
			</Grid>
		)
	} else {
		return (
			<Grid item container alignItems="center" spacing={3}>
				{chartSkills.map(({ id, name, color }) => (
					<Grid item key={id}>
						<TalentGroupToggle onClick={() => handleGroupToggle(id)}>
							<ToggleColor color={color} />
							<Typography
								variant="paragraph1"
								component="span"
								sx={{
									color: groupSelectionMapping[id] ? 'secondary' : theme.border
								}}
							>
								{name}
							</Typography>
						</TalentGroupToggle>
					</Grid>
				))}
			</Grid>
		)
	}
}

export default TalentGroupFilters
